import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "py-3 mx-auto max-w-7xl flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "md:ml-52 lg:ml-64 xl:ml-80 flex-grow flex flex-wrap pl-3 pr-5"
}
const _hoisted_3 = {
  class: "font-display font-extrabold text-4xl truncate md:text-5xl my-1 mr-3 flex-grow",
  style: {"line-height":"1.25"}
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full mt-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sr-only" }, "Badges", -1)
const _hoisted_7 = { class: "flex-grow flex items-center space-x-1 mr-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sr-only" }, "Metrics", -1)
const _hoisted_9 = { class: "self-center flex space-x-3" }
const _hoisted_10 = { class: "py-1 px-4 bg-purple-700 rounded-full flex justify-center text-white font-bold" }
const _hoisted_11 = { class: "py-1 px-4 bg-white text-black rounded-full flex justify-center font-bold" }
const _hoisted_12 = { class: "w-full max-w-full mt-5 flex" }
const _hoisted_13 = { class: "w-16 md:w-52 lg:w-64 xl:w-80 flex-shrink-0 flex flex-col space-y-2 pl-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "w-64 dark:border-gray-700 hidden md:block" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_16 = { class: "hidden md:block" }
const _hoisted_17 = { class: "p-3 border-gray-300 dark:border-gray-700 border-2 border-dashed rounded-md flex flex-wrap justify-center items-center font-medium text-base text-gray-400 text-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Have a suggestion?", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Share your experience!", -1)
const _hoisted_20 = {
  href: "https://forms.gle/VsuVJsqdChBuhDdM7",
  target: "_blank",
  rel: "noreferrer",
  class: "whitespace-nowrap m-1 border-2 border-gray-400 px-3 py-1 rounded-md font-medium flex items-center space-x-2 hover:bg-gray-400 hover:bg-opacity-10"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Feedback", -1)
const _hoisted_22 = {
  href: "https://github.com/NEAR-Edu/stats.gallery/issues/new/choose",
  target: "_blank",
  rel: "noreferrer",
  class: "whitespace-nowrap m-1 border-2 border-gray-400 px-3 py-1 rounded-md font-medium flex items-center space-x-2 hover:bg-gray-400 hover:bg-opacity-10"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Reports", -1)
const _hoisted_24 = { class: "flex-1 w-0 p-5 pl-3 -mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CombinedTopBar = _resolveComponent("CombinedTopBar")!
  const _component_BadgeTooltip = _resolveComponent("BadgeTooltip")!
  const _component_Star = _resolveComponent("Star")!
  const _component_near_symbol = _resolveComponent("near-symbol")!
  const _component_SectionLink = _resolveComponent("SectionLink")!
  const _component_AnnotationIcon = _resolveComponent("AnnotationIcon")!
  const _component_ContactIcon = _resolveComponent("ContactIcon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CombinedTopBar, { showIntake: true }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.account)
        ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.account), 1),
            _createElementVNode("div", {
              class: "flex items-center space-x-1",
              innerHTML: _ctx.tweetButton
            }, null, 8, _hoisted_4),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badgeGroups, (badge) => {
                return (_openBlock(), _createBlock(_component_BadgeTooltip, {
                  key: badge.badge_name,
                  name: badge.badge_name,
                  description: badge.badge_description,
                  fraction: badge.rarity_fraction,
                  group: badge.group,
                  achieved: badge.achieved
                }, null, 8, ["name", "description", "fraction", "group", "achieved"]))
              }), 128))
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Star, { class: "text-blue-500" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.number.standard(_ctx.accountLevel.level)), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$filters.number.standard(_ctx.score)), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_near_symbol, { class: "w-5 h-5" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$filters.number.standard(+_ctx.$filters.toNear(_ctx.accountView.amount))), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("nav", _hoisted_13, [
          (_ctx.account && _ctx.network && _ctx.timeframe)
            ? (_openBlock(), _createBlock(_component_SectionLink, {
                key: 0,
                to: {
            name: 'overview',
            params: { account: _ctx.account, network: _ctx.network },
            query: { t: _ctx.timeframe },
          },
                icon: _ctx.OverviewIcon,
                name: "Overview"
              }, null, 8, ["to", "icon"]))
            : _createCommentVNode("", true),
          (_ctx.account && _ctx.network && _ctx.timeframe)
            ? (_openBlock(), _createBlock(_component_SectionLink, {
                key: 1,
                to: {
            name: 'stats',
            params: { account: _ctx.account, network: _ctx.network },
            query: { t: _ctx.timeframe },
          },
                icon: _ctx.StatsIcon,
                name: "Stats"
              }, null, 8, ["to", "icon"]))
            : _createCommentVNode("", true),
          (_ctx.account && _ctx.network && _ctx.timeframe)
            ? (_openBlock(), _createBlock(_component_SectionLink, {
                key: 2,
                to: {
            name: 'transactions',
            params: { account: _ctx.account, network: _ctx.network },
            query: { t: _ctx.timeframe },
          },
                icon: _ctx.TransactionsIcon,
                name: "Transactions"
              }, null, 8, ["to", "icon"]))
            : _createCommentVNode("", true),
          (_ctx.account && _ctx.network && _ctx.timeframe)
            ? (_openBlock(), _createBlock(_component_SectionLink, {
                key: 3,
                to: {
            name: 'quests',
            params: { account: _ctx.account, network: _ctx.network },
            query: { t: _ctx.timeframe },
          },
                icon: _ctx.QuestsIcon,
                name: "Quests"
              }, null, 8, ["to", "icon"]))
            : _createCommentVNode("", true),
          (_ctx.account && _ctx.network && _ctx.timeframe)
            ? (_openBlock(), _createBlock(_component_SectionLink, {
                key: 4,
                to: {
            name: 'contract',
            params: { account: _ctx.account, network: _ctx.network },
            query: { t: _ctx.timeframe },
          },
                icon: _ctx.ContractIcon,
                name: "Contract"
              }, null, 8, ["to", "icon"]))
            : _createCommentVNode("", true),
          _createVNode(_component_SectionLink, {
            to: "/leaderboards",
            icon: _ctx.LeaderboardsIcon,
            name: "Leaderboards"
          }, null, 8, ["icon"]),
          _hoisted_14,
          _createVNode(_component_SectionLink, {
            to: "https://near.university/",
            icon: _ctx.AcademicCapIcon,
            name: "Learn NEAR",
            external: ""
          }, null, 8, ["icon"]),
          _createVNode(_component_SectionLink, {
            to: "https://near-in-minutes.com/",
            icon: _ctx.ClockIcon,
            name: "NEAR in Minutes",
            external: ""
          }, null, 8, ["icon"]),
          _createVNode(_component_SectionLink, {
            to: "https://www.mintbase.io/",
            icon: _ctx.NftIcon,
            name: "Buy NFTs",
            external: ""
          }, null, 8, ["icon"]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("a", _hoisted_20, [
                _createVNode(_component_AnnotationIcon, { class: "w-4 h-4" }),
                _hoisted_21
              ]),
              _createElementVNode("a", _hoisted_22, [
                _createVNode(_component_ContactIcon, { class: "w-4 h-4" }),
                _hoisted_23
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}